/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import DialogConfirmCancel from '../../../../../dialog/DialogConfirm';
import { Box, Radio } from '@mui/material';
import InputField from '../../../../../FormControl/input/InputField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelectLearningAreas from '../../SelectCustom/SelectLearningAreas';
import SelectYearLevel from '../../SelectCustom/SelectYearLevel';
import DataGrid from '../../../../../table/DataGrid';
import { useSelector } from 'react-redux';
import { getObjectCurriculumElementsDR } from '../../../utils';
import TextNotAssigned from '../../../../../text/TextNotAssigned';
import TextEllipsis from '../../../../../text/TextEllipsis';
import { useMarkingContext } from '../MarkingContext/MarkingContext';

const DialogClasses = ({ onClose, open, setFilterId, classId }) => {
  const years = useSelector((state) => state?.tenant?.years || []);

  const updateyearleves = (row) => {
    const yearlevel = years.filter((year) => row.yearLevel.includes(year._id));
    return {
      ...row,
      yearLevelName: yearlevel.map((year) => year.name).join(', ')
    };
  };
  const { listClasses, loadingClasses, curriculumList } = useMarkingContext();
  const [filter, setFilter] = useState({});
  const [clss, setClass] = useState(classId);
  const [list, setList] = useState(listClasses.map((row) => updateyearleves(row)));

  const onChangeFilter = (name, value) => {
    setFilter((old) => ({ ...old, [name]: value }));
  };

  const onFind = () => {
    const find = listClasses.find((item) => item._id === clss);
    setFilterId({
      classId: clss,
      classCode: find.code,
      learningArea: find?.curriculumElements?.elementId?.value,
      yearLevel: find.yearLevel,
      clss: find
    });
    onClose();
  };

  useEffect(() => {
    if (filter) {
      const listFilter = listClasses.filter((item) => {
        let result = true;
        if (filter.code) {
          result = item.code.toLowerCase().includes(filter.code.toLowerCase());
        }
        if (filter.learningArea) {
          result = result && item?.curriculumElements?.elementId?.value === filter.learningArea;
        }
        if (filter.yearLevel) {
          result = result && item?.yearLevel?.includes(filter.yearLevel);
        }
        return result;
      });
      setList(listFilter);
    }
  }, [filter]);

  const onLoadData = useCallback(async () => {
    if (listClasses) {
      setList(listClasses.map((row) => updateyearleves(row)));
    }
  }, [listClasses]);

  useEffect(() => {
    onLoadData();
  }, [onLoadData]);

  return (
    <DialogConfirmCancel
      id='periodical-report-filter-classes'
      open={open}
      title='Filter classes'
      onCancel={onClose}
      onConfirm={onFind}
      disabledConfirm={!clss}
      textConfirm='Apply'
      maxWidth='md'
    >
      <div className='h-screen-modal-content-footer overflow-auto'>
        <Box className='px-4 py-2 h-10 border-b border-b-2 border-primary text-primary flex items-center justify-between'>
          <div className='flex gap-4 items-center'>
            <div className='relative'>
              <span className='text-primary text-xs h-10 w-10'>
                <FontAwesomeIcon icon='bars-filter' className='text-3xl' />
              </span>
            </div>
            <div className='min-w-150px max-w-150px flex flex-col relative'>
              <span className='text-primary absolute text-xs' style={{ top: '-0.75rem' }}>
                Class code
              </span>
              <InputField
                id='class-code'
                variant='outlined'
                fullWidth
                size='small'
                disabled={loadingClasses}
                onChange={(e) => onChangeFilter('code', e.target.value)}
              />
            </div>
            <div className='min-w-150px max-w-150px flex flex-col relative'>
              <span className='text-primary absolute text-xs' style={{ top: '-0.75rem' }}>
                Learning area
              </span>
              <SelectLearningAreas
                onChange={(e) => onChangeFilter('learningArea', e.target.value)}
                onClear={() => onChangeFilter('learningArea', '')}
                disabled={loadingClasses}
                value={filter.learningArea}
              />
            </div>
            <div className='min-w-150px max-w-150px flex flex-col relative'>
              <span className='text-primary absolute text-xs' style={{ top: '-0.75rem' }}>
                Year level
              </span>
              <SelectYearLevel
                value={filter.yearLevel}
                onChange={(e) => onChangeFilter('yearLevel', e.target.value)}
                onClear={() => onChangeFilter('yearLevel', '')}
                disabled={loadingClasses}
              />
            </div>
          </div>
        </Box>
        <Box className='absolute top-20 bottom-4 inset-x-4'>
          <DataGrid
            showSetting={false}
            id='periodical-report-classes'
            rows={list.map((row, index) => {
              const yearlevel = years.filter((year) => row.yearLevel.includes(year._id));
              const currentCurriculum = curriculumList?.find((item) => item._id === row.curriculumId);
              const elements = getObjectCurriculumElementsDR(
                currentCurriculum?.elements,
                currentCurriculum?.elementsStructure,
                row?.curriculumElements || {}
              );
              return {
                ...row,
                index: index + 1,
                yearLevel: yearlevel.map((year) => year.name).join(', '),
                radioCheck: (
                  <Radio checked={clss === row._id} onChange={() => setClass(row._id)} name='radio-classes' />
                ),
                curriculum: row?.curriculumId ? (
                  <div className='max-w-300px'>
                    <TextEllipsis className='text-sm'>
                      {currentCurriculum?.shortName} - {currentCurriculum?.name}
                    </TextEllipsis>
                    {elements?.element?.valueName && (
                      <div className='flex gap-1 items-center'>
                        <span className='text-xs font-bold text-nowrap'>{elements?.element?.keyName}</span>
                        <TextEllipsis className='text-xs'>{elements?.element?.valueName}</TextEllipsis>
                      </div>
                    )}
                    {elements?.subElement?.valueName && (
                      <div className='flex gap-1 items-center'>
                        <span className='text-xs font-bold text-nowrap'>{elements?.subElement?.keyName}</span>
                        <TextEllipsis className='text-xs'>{elements?.subElement?.valueName}</TextEllipsis>
                      </div>
                    )}
                  </div>
                ) : (
                  <TextNotAssigned />
                )
              };
            })}
            loading={loadingClasses}
            totalRows={0}
            skip={0}
            rowsPerPage={50}
            columns={[
              { label: '#', key: 'index', align: 'center', width: 10, show: true, hide: false },
              {
                label: '',
                key: 'radioCheck',
                align: 'center',
                className: 'text-center',
                width: 10,
                show: true,
                hide: false
              },
              {
                label: 'class Curriculum',
                key: 'curriculum',
                align: 'left',
                width: 250,
                show: true,
                hide: true,
                position: 1
              },
              {
                label: 'class Code',
                key: 'code',
                align: 'left',
                width: 100,
                show: true,
                hide: true,
                position: 2
              },
              {
                label: 'Year level',
                key: 'yearLevel',
                align: 'left',
                width: 250,
                show: true,
                hide: true,
                position: 3
              }
            ]}
            labelNoRows="You don't have any classes yet"
          />
        </Box>
      </div>
    </DialogConfirmCancel>
  );
};
export default DialogClasses;
